/**
 * `/setup` — la rotta storica del Setup wizard, che creava un tenant da zero.
 *
 * Dal 10-09-2026 la creazione sta in `/onboarding` (dal 02-11-2026 «Nuova azienda», ed è tutto lì):
 * è il percorso con cui il Master crea l'azienda di un cliente. La rotta resta per i segnalibri e per
 * i documenti che la citano.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/setup')({
  component: () => <Navigate to="/onboarding" replace />,
});
